import { Badge } from "reactstrap";
import {
  alternateRecommendationBadgeColor,
  alternateRecommendationBomLineText,
  alternateRecommendationText,
  hasAlternateRecommendationBadge,
  isVisibleAlternateRecommendationLabel,
} from "../constants/digiKeyColumns";

const AlternateRecommendationBadge = ({
  label,
  text,
  onlyRecommended = false,
  bomLine = false,
  className = "",
}) => {
  if (onlyRecommended && !isVisibleAlternateRecommendationLabel(label)) {
    return null;
  }

  if (bomLine && !hasAlternateRecommendationBadge(label)) {
    return null;
  }

  const display = bomLine
    ? alternateRecommendationBomLineText(label, text)
    : String(text || alternateRecommendationText(label) || "").trim();
  if (!display) {
    return null;
  }

  return (
    <Badge
      color={alternateRecommendationBadgeColor(label)}
      className={`obsolete-rec-badge obsolete-rec-badge--${label || "none"} ${
        bomLine ? "obsolete-rec-badge--bom-line" : ""
      } ${className}`.trim()}
    >
      {display}
    </Badge>
  );
};

export const SelectedAlternateMpnRow = ({
  mpn,
  mpnClassName = "obsolete-selected-mpn",
  label,
  text,
}) => (
  <span className="obsolete-mpn-primary">
    <span className={mpnClassName}>{mpn}</span>
    <AlternateRecommendationBadge bomLine label={label} text={text} />
  </span>
);

export default AlternateRecommendationBadge;
